import { userService } from "./user.service";
import { orgConferencesActions, teamActions, userActions, studentConferencesActions } from "../_actions";
import { store, tSafe } from "../_helpers";
import { showGlobalSnackbar } from "./snackbarService";

const load = (url, action) => {
  // Проверка токена именно ДО loading(true): при обратном порядке ранний return
  // оставлял глобальный спиннер (user.isLoading, рисуется в MainPage) включённым
  // навсегда — экран затемнён, ни одна кнопка не нажимается, и лечится только
  // перезапуском приложения.
  const token = localStorage.getItem("token");
  if (!token) return; //для неавторизованных ничего не загружаем

  store.dispatch(userActions.loading(true));

  userService.getWrapper(
    url,
    (data) => {
      store.dispatch(userActions.loading(false));
      if (data.data) {
        store.dispatch(action(data.data));
      }
    },
    (error) => {
      store.dispatch(userActions.loading(false));
      if (error !== "") {
        console.log(error);
        // Без ответа сервера страница остаётся пустой: список мероприятий не
        // пришёл, а getWrapper про обрыв связи молчит. Человеку нужно понимать,
        // что дело в связи, а не в том, что мероприятий нет.
        if (!error.response) showGlobalSnackbar(tSafe("network_error"), "error");
      }
    }
  );
};

export const reduxLoader = {
  orgConferences: () => load("api/conference", orgConferencesActions.load),
  studentConferences: () => load("api/conference-all?hasTicket=1", studentConferencesActions.load),
  team: () => load("api/team?withOrg=1", teamActions.load),
};
